<template>
  <div class="warp">
    <el-form inline size="mini">
      <el-form-item label="Source of Data:">
        <select-box
          width="200"
          :options="originData"
          :value.sync="extraData.dataSourceCode"
          placeholder="Please select source of data"
        />
      </el-form-item>

      <el-form-item label="Status:">
        <select-box
          width="160"
          :options="statusOptions"
          :value.sync="extraData.status"
        />
      </el-form-item>
           <el-form-item label="Ignore" >
        <el-select v-model="extraData.ignore" placeholder="Select" clearable="">
          <el-option label="Yes" :value="true"></el-option>
          <el-option label="No" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Source ID:">
        <el-input
          style="width:240px"
          clearable
          v-model="extraData.sourceId"
          placeholder="Please typing in source ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="Source Name:">
        <el-input
          style="width:200px"
          clearable
          v-model="extraData.thirdName"
          placeholder="Please typing in source name"
        ></el-input>
      </el-form-item>
      <el-form-item label="Source Sport:">
        <!-- <input-autocomplete
          :extraData.sync="extraData.thirdSportsName"
          search-key="STD_SEARCH_SPORT"
          value-key="sportsName"
          label-key="id"
          query-key="name"
          :queryOrderParams="{ page: 1, size: 500 }"
        /> -->
          <select-box
          :url="STD_SEARCH_SPORT"
          :remote="false"
          :queryOrderParams="{ page: 1, size: 500 }"
          :value.sync="extraData.sportId"
          placeholder="Select"
          label-key="sportsName"
          value-key="id"
        />
      </el-form-item>

      <el-form-item label="Source Region:">
        <el-input
          style="width:200px"
          clearable
          v-model="extraData.thirdRegionName"
          placeholder="Please typing in source region name"
        />
      </el-form-item>
      <el-form-item label="Standard Name:">
        <select-box
          :url="STD_SEARCH_TOURNAMENT"
          :queryOrderParams="{ page: 1, size: 100 }"
          :value.sync="extraData.standardName"
          search-key="name"
          label-key="name"
          value-key="name"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search"
          >Search</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      v-loading="loading"
      @sort-change="sort"
      :max-height="tableHeight"
    >
      <el-table-column
        label="Source of Data"
        width="140"
        align="center"
        prop="dataSourceCode"
      >
        <template v-slot="{ row }">
          {{ originMapping[row.dataSourceCode] }}
        </template></el-table-column
      >
      <el-table-column
        class-name="yellow-col"
        label="source ID"
        width="140"
        align="center"
        prop="sourceTournamentId"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        class-name="yellow-col"
        label="Standard ID"
        min-width="160"
        align="center"
        prop="standardTournamentId"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        class-name="green-col"
        label="source Name"
        min-width="180"
        align="center"
        prop="thirdTournamentName"
      >
        <template v-slot="{ row }">
          <div
            :class="{
              red:
                row.status &&
                compare(row.thirdTournamentName, row.standardTournamentName)
            }"
          >
            {{ row.thirdTournamentName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        class-name="green-col"
        label="Standard Name"
        min-width="160"
        align="center"
        prop="standardTournamentName"
      ></el-table-column>
      <el-table-column
        class-name="yellow-col"
        label="source Sports"
        min-width="180"
        align="center"
        prop="thirdSportsName"
      >
        <template v-slot="{ row }">
          <div
            :class="{
              red:
                row.status &&
                compare(row.thirdSportsName, row.standardSportsName)
            }"
          >
            {{ row.thirdSportsName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        class-name="yellow-col"
        label="Standard Sports"
        min-width="160"
        align="center"
        prop="standardSportsName"
      ></el-table-column>
      <el-table-column
        class-name="green-col"
        label="Source Region"
        min-width="160"
        align="center"
        prop="thirdRegionName"
      >
        <template v-slot="{ row }">
          <div
            :class="{
              red:
                row.status &&
                compare(row.thirdRegionName, row.standardRegionName)
            }"
          >
            {{ row.thirdRegionName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        class-name="green-col"
        label="Standard Region"
        min-width="160"
        align="center"
        prop="standardRegionName"
      ></el-table-column>
      <el-table-column
        class-name="yellow-col"
        label="Status"
        align="center"
        prop="shortName"
        width="120"
      >
        <template v-slot="{ row }">
          <p :class="{ red: !row.status, green: row.status }">
            • {{ row.status ? 'Mapped' : 'UnMapped' }}
          </p>
        </template>
      </el-table-column>
         <el-table-column label="Ignore">
        <template v-slot="{row}">
          <el-switch v-model="row.ignore"  @change="ignoreFn(row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="Remark"
        min-width="180"
        align="center"
        prop="remark"
      >
        <template v-slot="{ row }">
          <dropdown
            :row="{
              thirdId: row.thirdTournamentId,
              dataSourceCode: row.dataSourceCode,
              standardId: row.standardTournamentId
            }"
            :methodStr="methodStr"
            :text="`${row.remark || 'Please select'}`"
            @get-list="getList"
          />
        </template>
      </el-table-column>
      <el-table-column
        class-name="yellow-col"
        label="Operation"
        min-width="100"
        align="center"
        prop="shortName"
      >
        <template v-slot="{ row }">
          <el-link type="primary" :underline="false" @click="edit(row)"
            >Edit</el-link
          >
        </template>
      </el-table-column>
      <el-table-column label="Langauge" min-width="160" align="center">
        <template v-slot="{ row }">
          <div>
            <i class="el-icon-document-copy langaugeDetails" @click="showLangaugeDetail(row.standardTournamentId)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Log" min-width="160" align="center">
        <template v-slot="{ row }">
          <OperationType :dataType="'Third_Tournament'" :dataId="row.thirdTournamentId" />
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" style="margin-top: 20px">
      <el-pagination
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="pageSizes"
        @current-change="changePage"
        @size-change="handleSizeChange"
        :layout="pageLayout"
      ></el-pagination>
    </el-row>
    <el-dialog
      :title="dialog.title"
      width="500px"
      :visible.sync="dialog.show"
      :close-on-click-modal="dialog.clickModal"
    >
      <el-form
        :model="dialogForm"
        label-width="130px"
        size="mini"
        :ref="dialog.ref"
      >
        <el-form-item label="Source Name:">
          {{ dialogForm.thirdName }}
        </el-form-item>
        <el-form-item label="Standard Sports:" prop="sportId">
          <select-box
            :url="STD_SEARCH_SPORT"
            :queryOrderParams="{ page: 1, size: 500 }"
            :value.sync="dialogForm.sportId"
            :label="dialogForm.sportsName"
            search-key="name"
            label-key="sportsName"
            value-key="id"
          />
        </el-form-item>
        <el-form-item label="Standard Region:" prop="regionId">
          <select-box
            :url="STD_SEARCH_REGION"
            :queryOrderParams="{
              page: 1,
              size: 500,
              sportId: dialogForm.sportId, 
              deleteFlag: 1
            }"
            :value.sync="dialogForm.regionId"
            :label="dialogForm.regionName"
            search-key="name"
            label-key="name"
            value-key="id"
            @change="onSelectedDrug"
          />
        </el-form-item>
        <el-form-item label="Standard Name:" prop="standardId">
          <select-box
            :url="'tournament/validList'"
            :queryOrderParams="{
              page: 1,
              size: 100,
              sportId: dialogForm.sportId,
              regionId: dialogForm.regionId,
              isVisible: 1,
            }"
            :value.sync="dialogForm.standardId"
            :label="dialogForm.standardName"
            search-key="name"
            label-key="name"
            value-key="id"
          />
        </el-form-item>
        <!-- <el-form-item label="Ignore:" prop="remark">
          <el-switch v-model="dialogForm.ignore" ></el-switch>
        </el-form-item> -->
        <el-form-item label="Remark:" prop="remark">
          <el-input
            v-model="dialogForm.remark"
            placeholder="Please enter remark"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="dialogSubmit"
            :loading="dialog.isLoading"
            >Confirm</el-button
          >
          <el-button @click="dialogHide">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
        <el-dialog
      :title="langDialogData.title"
      width="500px"
      :visible.sync="langDialogData.show"
      :close-on-click-modal="langDialogData.clickModal"
      :destroy-on-close="true"
    > 
            <el-form
        :model="dialogForm"
        :rules="langRules"
        label-width="120px"
        size="mini"
        :ref="dialog.ref"
      >
        <el-form-item label="ID:" v-if="langDialogData.id">
          {{ langDialogData.id }}
        </el-form-item>
        <el-form-item
          v-for="item in langData"
          :prop="`language${item}`"
          :key="item"
          :label="`${item}:`"
        >
          <el-input
            v-if="langDialogData.data"
            v-model="langDialogData.data[item]"
            placeholder="Please typing in text"
            :disabled="item === 'ENG'"
            style="width:300px"
            maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="Remark:">
          <el-input
            v-model="langDialogData.remark"
            placeholder="Please typing in text"
            style="width:300px"
            maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="dialog.isLoading" @click="editLanguage(3)"
            >Confirm</el-button
          >
          <el-button @click="langDialogData.show = false">Cancel</el-button>
        </el-form-item>
      </el-form>
  </el-dialog>
  </div>
</template>

<script>
import {
  getTournamentMappingList as getData,
  editTournamentMapping as editData,
  changeThirdTournament
} from '@/service/subscribe'
import { queryTournamentInternational as getLangaugeDetail } from '@/service/standard'
import TableMixin from '@/mixins/subscibe/table'
import Dropdown from '@/components/Dropdown'
import LangMixin from '@/mixins/lang'
export default {
  name: 'tournamentMapping',
  mixins: [TableMixin, LangMixin],
  components: { Dropdown },
  data() {
    return {
      methodStr: 'editTournamentMapping',
      extraData: {
        standardName: ''
      }
    }
  },
  methods: {
    getLangaugeDetail,
    async ignoreFn(row) {
      const data = await changeThirdTournament({id: row.thirdTournamentId, ignore: row.ignore})
      if (data.code === 0) {
        this.$message.success('Success')
        this.getList && this.getList()
      }
    },
    getData(e) {
       return getData(this.fliterParams(e,['sourceId']))
    },
    editData,
    edit(row) {
      const data = {
        thirdId: row.thirdTournamentId,
        standardId: row.standardTournamentId,
        standardName: row.standardTournamentName,
        thirdName: row.thirdTournamentName,
        sourceId: row.sourceTournamentId,
        dataSourceCode: row.dataSourceCode,
        remark: row.remark,
        sportId: row.standardSportsId || '',
        regionId: row.standardRegionId,
        regionName: row.standardRegionName
      }
      this.dialogEdit(data)
    },
    onSelectedDrug() {
      this.dialogForm.standardId = null
      this.dialogForm.standardName = null
    },
    compare(a, b) {
      return (a || '').toLowerCase() !== (b || '').toLowerCase()
    },
    async dialogSendData() {
      let data
      try {
        let params = {
          thirdId: this.dialogForm.thirdId,
          standardId: this.dialogForm.standardId,
          remark: this.dialogForm.remark,
          dataSourceCode: this.dialogForm.dataSourceCode,
          sourceId: this.dialogForm.sourceId,
          ignore: this.dialogForm.ignore
        }
        data = await this.editData(params)
        if (data.code === 0) {
          this.getList && this.getList()
          this.dialogHide()
          this.$message({
            message: 'Successful operation',
            type: 'success'
          })
        } else {
          this.dialog.isLoading = false
        }
      } catch (error) {
        this.dialog.isLoading = false
      }
    }
  }
}
</script>
